export const ROUTE_PATH = '/clean/cleaner/login' as const
